import { IAuthFromGeneric } from 'components/templates/Auth-from-generic/models/Auth-from-generic.interface';
import { isConnect } from 'utils/branding.util';

export const headerInformation: IAuthFromGeneric['headerInformation'] = {
  title: 'Bienvenido/a',
  text: `Gestiona tus planes con ${
    isConnect ? 'Connect' : 'Soda'
  } en un solo lugar, sencillo y seguro.`,
};
export const activeBenefitsHeaderInformation: IAuthFromGeneric['headerInformation'] =
  {
    title: 'Bienvenido/a',
    text: 'Regístrate para recibir tu descuento',
  };
